import { useSync } from '../sync/service.ts';

/** Shown when the server refuses this client's schema (426) or a doc needs a newer app. */
export function UpdateBanner() {
  const required = useSync((s) => s.updateRequired);
  if (!required) return null;
  return (
    <div
      role="alert"
      className="fixed inset-x-0 top-0 z-[80] flex items-center justify-center gap-3 bg-accent px-4 py-2 text-accent-ink"
      style={{ paddingTop: 'calc(var(--safe-top) + 8px)' }}
    >
      <span className="t-label">A newer version of Better Lights is needed to keep syncing.</span>
      <button
        type="button"
        className="t-label rounded-md bg-black/15 px-3 py-1 font-semibold"
        onClick={() => location.reload()}
      >
        Update app
      </button>
    </div>
  );
}
